@if(!isLoading){
<div
  class="top-div w-100 d-flex justify-content-between align-items-center flex-row"
>
  <span class="accello-service-text">{{ operationData.name }}</span>
  <div class="d-flex flex-row align-items-center justify-content-start">
    <div class="r-type header-8">{{ operationData.type }}</div>
    <div class="url-div">{{ operationData.url }}</div>
    <div (click)="selectReturnType()" class="return-type header-8 clickable" (keydown.enter)="selectReturnType()">
      Return Type
    </div>
  </div>
  <!-- <button class="release-btn btn-accello-secondary" (click)="saveOperation()">
    <img
      [src]="'images/virtusa-icons/save-purple.svg' | assetUrl"
      alt="Add Icon"
      width="18"
      height="18"
    />
    Save Operation
  </button> -->
</div>

<div class="h-100">
  <app-tab [tabs]="tabs"></app-tab>
</div>
} @else{
<app-loading
  class="h-100 w-100 loading-container"
  [text]="'Loading'"
></app-loading>
}
